<template>
  <div>
   <!-- <div style="height: 60px;background-color: #1c3784;width: 100%"></div>-->
    <div class="container">
      <div class="row">
        <div class="news_nav">
          <span>主页 > 附件一</span>
        </div>
        <div class="col-sm-8 news_content" style="padding-top: 30px;width: 1200px;margin: 0 auto">
          <h2 style="font-size: 30px;text-align: center">第一届全国大学生生态环境管理科研创新大赛参赛作品排版格式</h2>
          <p style="font-size: 17px;font-weight: bold;margin-top: 40px">
            （一）内容规范
          </p>
          <p>
            &emsp;&emsp;&emsp;&emsp;参赛作品包括封面和作品正文等内容。
          </p>
          <p style="font-size: 17px;font-weight: bold">
            （二）封面内容
          </p>
          <p>
            &emsp;&emsp;&emsp;&emsp;作品名称<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;作者团队（所有成员姓名、学校、年级）<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;指导教师（姓名、单位）
          </p>
          <p style="font-size: 17px;font-weight: bold">
            （三）正文内容
          </p>
          <p>
            &emsp;&emsp;&emsp;&emsp;作品摘要<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;研究背景和研究问题<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;研究过程（数据和模型、详细的计算或调研过程、充分的论证过程等）<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;研究结论与发现<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;参考文献<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;各成员贡献、致谢
          </p>
          <p style="font-size: 17px;font-weight: bold">
            （四）格式要求
          </p>
          <p>
            <span
              style="font-size: 14px;font-weight: bold">&emsp;&emsp;&emsp;&emsp;文件命名方式：</span><span>学校名称_第一作者姓名</span><br>
            <span style="font-size: 14px;font-weight: bold">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;作品正文：</span><br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;[1]&emsp;页边距：上下左右均3.0cm；页眉及页脚：均2.0cm；<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;[2]&emsp;行距：1.25倍行距，段前、段后均为0；<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;[3]&emsp;正文：宋体、字号小四；<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;[4]&emsp;每章的章标题：黑体，居中，字号小三，1.5倍行距，章序号为阿拉伯数字（如第1章）；<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;[5]&emsp;章中的各级标题：黑体，居左，字号小四；<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;[6]&emsp;正文中的图、表、附注、公式一律采用阿拉伯数字分章编号；<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;[7]&emsp;参考文献采用阿拉伯数字根据全文统一编号，如文献[3]；<br>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;[8]&emsp;在正文中引用时用右上角标标出。
          </p>
          <p style="font-size: 17px;font-weight: bold">
            （四）提交要求
          </p>
          <p>
            &emsp;&emsp;&emsp;&emsp;参赛作品需按照时间要求，上传至活动官网。
          </p>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "LayoutDesigner"
  }
</script>

<style scoped>

  .news_nav{
    font-size: 15px;
    color: #333;
    line-height: 30px;
    margin: 30px auto;
    padding-bottom: 30px;
    border-bottom: 1px solid #eee;
    width: 1200px;
    text-align: right
  }
  .news_content p{
    font-size: 14px;
    line-height: 32px;
    margin-bottom: 25px;
    text-indent:2em;
  }
</style>



// WEBPACK FOOTER //
// src/page/Layout/LayoutDesigner.vue